import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-office-moves',
  templateUrl: './office-moves.component.html',
  styleUrls: ['./office-moves.component.scss']
})
export class OfficeMovesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
